import { scrollToSection } from "@/lib/scroll";

const LINKS = [
  { label: "Business Impact", id: "business-impact" },
  { label: "AI Features", id: "ai-features" },
  { label: "Testimonials", id: "testimonials" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="landing-footer"
      className="border-t border-black/[0.06] bg-white px-6 py-12 lg:px-10"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 sm:flex-row sm:items-center">
        <div className="flex items-center gap-2.5">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#0a0a0a] text-[13px] font-heading font-bold text-white">
            A
          </span>
          <span className="font-heading text-[15px] font-bold tracking-tight text-[#0a0a0a]">
            AMRA <span className="text-brand-teal">AI</span> Business OS
          </span>
        </div>

        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
          {LINKS.map((link) => (
            <button
              key={link.id}
              data-testid={`footer-link-${link.id}`}
              onClick={() => scrollToSection(link.id)}
              className="text-sm text-[#52525b] transition-colors hover:text-[#0a0a0a]"
            >
              {link.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="mx-auto mt-10 max-w-7xl border-t border-black/[0.06] pt-6">
        <p className="font-mono text-xs text-[#a1a1aa]">
          © {new Date().getFullYear()} AMRA Decorations — AMRA AI Business OS.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
